import React, { useState } from "react";
import {
  FaAndroid,
  FaGlobe,
  FaProjectDiagram,
  FaShoppingCart,
  FaUserTie,
} from "react-icons/fa";
import nestingcategory from "../../../assets/Docs/nestedCatgory.png";
import MainCategory from "../../../assets/Docs/MainCategory.png";
import { TagComponent } from "../Tabs";

const CategoryNesting = () => {
  const [activeTab, setActiveTab] = useState("web");

  const tabs = [
    { id: "web", label: "Web App View" },
    { id: "mobile", label: "Mobile App View", disabled: true },
  ];

  const renderTabs = () => (
    <div className="flex border-b gap-3 border-[#b9ece6]">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={`px-4 py-2 font-medium text-sm transition-colors duration-200 rounded-t-md ${activeTab === tab.id
            ? "border-b-2 border-[#1a9588] bg-[#1a9588] text-white"
            : "text-gray-500 bg-[#dbf4f1]"
            } ${tab.disabled
              ? "opacity-50 cursor-not-allowed"
              : "hover:text-gray-700 hover:bg-[#b9ece6]"
            }`}
          onClick={() => !tab.disabled && setActiveTab(tab.id)}
          disabled={tab.disabled}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );

  return (
    <div className="bg-white shadow-lg rounded-xl p-6 sm:p-8  mx-auto border border-gray-200" id="top">

      <div className="flex items-center mb-6 border-b pb-4 border-gray-200">
        <FaProjectDiagram className="text-4xl text-theme-logo-color mr-3" />
        <h1 className="text-2xl sm:text-3xl font-bold text-theme-logo-color">Category Nesting</h1>


      </div>

      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaUserTie />} label="Seller" color="green" />
          <TagComponent icon={<FaShoppingCart />} label="Buyer" color="pink" />
        </div>
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaGlobe />} label="Web" color="green" />
          <TagComponent icon={<FaAndroid />} label="Android" color="green" />
        </div>
      </div>

      <hr />

      <div className="flex flex-col md:flex-row gap-8 scroll-smooth">
        <div className="md:w-3/4 lg:w-3/4 w-full p-4 text-start">
          <div id="start-setup" className="scroll-mt-20">
            <p className="text-gray-600 mb-6">
              Your Selzor Product catalogue features multi-level category nesting
              structure. Every product can be added to multiple categories. Once
              these categories have been defined, they can be grouped using
              nesting categories.
            </p>
            <p className="text-gray-600 mb-6">
              Nesting Categories are used for navigation purposes. They can
              contain both product categories (which are linked with products) &
              other nesting categories as children.
            </p>

            <div>
              <h4 className="text-xl md:text-2xl font-semibold text-gray-500 mb-4">
                Add Main Category
              </h4>

              {renderTabs()}
              <div className="mt-4 p-4 border border-gray-200 rounded-lg">
                {activeTab === "web" && (
                  <img
                    src={MainCategory}
                    alt="Web App View of Seller Setup"
                    className="w-full h-auto"
                  />
                )}
                {activeTab === "mobile" && (
                  <div className="text-center text-gray-500">
                    Mobile App View is disabled for this section.
                  </div>
                )}
              </div>
            </div>

            <div className="my-5">
              <h4 className="text-xl md:text-2xl font-semibold text-gray-500 mb-4">
                Add Sub Category
              </h4>
              {renderTabs()}
              <div className="mt-4 p-4 border border-gray-200 rounded-lg">
                {activeTab === "web" && (
                  <img
                    src={nestingcategory}
                    alt="Web App View of Seller Setup"
                    className="w-full h-auto"
                  />
                )}
                {activeTab === "mobile" && (
                  <div className="text-center text-gray-500">
                    Mobile App View is disabled for this section.
                  </div>
                )}
              </div>
            </div>
          </div>
          <div
            className="bg-yellow-50 border border-yellow-100 text-yellow-600 px-4 py-3 rounded relative my-4"
            role="alert"
          >
            <p>
              Maximum nesting depth level is 10. You can also assign a photo for
              every category.
            </p>
          </div>
          <hr className="my-6" />
        </div>
      </div>
    </div>
  );
};

export default CategoryNesting;
